import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Radar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, useApi } from "@/lib/api";

export function ProbeResult({ p, testid }) {
  if (!p) return null;
  return (
    <p className={`mt-1.5 text-xs ${p.ok ? "text-emerald-700" : "text-red-600"}`} data-testid={testid}>
      {p.status ? `HTTP ${p.status} · ${p.ms} ms` : p.error}{p.title && ` · «${p.title}»`}{p.status && (p.robots ? " · noindex" : " · indicizzabile")}
    </p>
  );
}

export default function EdgeProbe({ siteId, which }) {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const [p, setP] = useState(null);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/sites/${siteId}/edge-probe`, { which }); setP(data); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div>
      <Button size="sm" variant="outline" className="h-7 px-2 text-xs" onClick={run} disabled={busy} data-testid={`probe-${which}-btn`}>
        {busy ? <Loader2 size={12} className="mr-1 animate-spin" /> : <Radar size={12} className="mr-1" />}Prova dal server</Button>
      <ProbeResult p={p} testid={`probe-${which}-result`} />
    </div>
  );
}
